import type maplibregl from 'maplibre-gl';

/**
 * Illuminated cuadra on the exploration map.
 *
 * Same visual language as the assistant's confirmed-place moment (line + soft
 * glow, fade-in), adapted to the light basemap: the product ink accent instead
 * of the dark-mode cyan. The map should feel like it "took" the place.
 */

const SRC = 'vsj-selected-place';
const LAYER_GLOW = 'vsj-selected-place-glow';
const LAYER_LINE = 'vsj-selected-place-line';

const ACCENT = '#1a1a2e';

export function clearSelectedPlace(map: maplibregl.Map): void {
  try {
    if (map.getLayer(LAYER_GLOW)) map.removeLayer(LAYER_GLOW);
  } catch (_e) {
    /* map may be mid-teardown */
  }
  try {
    if (map.getLayer(LAYER_LINE)) map.removeLayer(LAYER_LINE);
  } catch (_e) {
    /* map may be mid-teardown */
  }
  try {
    if (map.getSource(SRC)) map.removeSource(SRC);
  } catch (_e) {
    /* map may be mid-teardown */
  }
}

export function showSelectedPlace(map: maplibregl.Map, geometry: object): void {
  clearSelectedPlace(map);

  try {
    map.addSource(SRC, {
      type: 'geojson',
      data: { type: 'Feature', geometry: geometry as never, properties: {} },
    });

    map.addLayer({
      id: LAYER_GLOW,
      type: 'line',
      source: SRC,
      layout: { 'line-cap': 'round', 'line-join': 'round' },
      paint: { 'line-color': ACCENT, 'line-width': 11, 'line-blur': 8, 'line-opacity': 0 },
    });

    map.addLayer({
      id: LAYER_LINE,
      type: 'line',
      source: SRC,
      layout: { 'line-cap': 'round', 'line-join': 'round' },
      paint: { 'line-color': ACCENT, 'line-width': 3.5, 'line-opacity': 0 },
    });

    // Transition props are runtime-valid but missing from the paint typings.
    map.setPaintProperty(
      LAYER_LINE,
      'line-opacity-transition' as never,
      {
        duration: 500,
      } as never
    );
    map.setPaintProperty(
      LAYER_GLOW,
      'line-opacity-transition' as never,
      {
        duration: 750,
      } as never
    );

    window.setTimeout(() => {
      try {
        map.setPaintProperty(LAYER_LINE, 'line-opacity', 0.85);
        map.setPaintProperty(LAYER_GLOW, 'line-opacity', 0.16);
      } catch (_e) {
        /* layers may have been cleared before the fade fired */
      }
    }, 40);
  } catch (_e) {
    /* degrade to marker-only if the style is not ready */
  }
}
